// "Trusted by Leading Clients" strip.
//
// ADD A LOGO: put the file (SVG recommended, or PNG/WebP/JPG) in  src/assets/clients/
// Logos appear in file-name order. Only list clients that have agreed to be shown.
//
// OPTIONAL institute name under a logo: add it to `names`, keyed by the file name without
// its extension, e.g.  'school-logo-00': 'Institute Name'.  Leave empty to show the logo only.

const names = {};

const files = require.context('../assets/clients', false, /\.(svg|png|jpe?g|webp)$/i);

const fromFolder = files
  .keys()
  .sort()
  .map((key) => {
    const stem = key.replace(/^\.\//, '').replace(/\.[^.]+$/, '');
    const mod = files(key);
    return {
      name: stem.replace(/[-_]+/g, ' '),
      label: names[stem] || '',
      logo: typeof mod === 'string' ? mod : mod.default,
    };
  });

// Shown until real logos are added.
const placeholders = Array.from({ length: 6 }, () => ({ name: 'Client Logo', label: '', logo: '' }));

export const clients = {
  title: 'Trusted by Leading Clients',
  text: 'Schools, colleges and institutions across Bangladesh rely on our software and platforms every day.',
  items: fromFolder.length ? fromFolder : placeholders,
};
